import React from "react";
import { SvgIcon } from "@mui/material";

function LearnIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" color={props.color}>
      <svg
        id="svg"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0, 0, 400,400"
      >
        <g id="svgg">
          <path
            id="path0"
            d="M126.038 38.191 C 109.837 42.526,98.345 60.300,100.933 77.021 C 106.193 111.003,152.105 118.554,167.242 87.927 C 180.888 60.316,155.932
            30.193,126.038 38.191 M268.010 124.114 C 240.868 171.182,218.673 209.947,218.689 210.260 C 218.719 210.866,276.581 244.524,278.491 245.046
            C 279.473 245.315,377.502 77.246,378.280 73.959 C 378.480 73.117,319.700 38.500,318.113 38.524 C 317.698 38.531,295.152 77.046,268.010 124.114 M91.848 126.850 C
            83.117 128.950,73.175 136.779,69.148 144.726 C 64.895 153.119,64.906 152.956,64.906 208.083 L 64.906 258.868 78.113 258.868 L 91.321 258.868 91.321 325.660 L
            91.321 392.453 135.849 392.453 L 180.377 392.453 180.377 325.660 L 180.377 258.868 193.585 258.868 L 206.792 258.868 206.774 207.736 C 206.763 176.010,206.466
            155.347,205.992 153.292 C 203.668 143.211,196.589 134.579,186.574 129.616 L 180.117 126.415 137.417 126.287 C 113.710 126.217,93.441
            126.467,91.848 126.850 M171.895 192.642 L 172.092 224.151 158.499 224.151 L 144.906 224.151 144.906 290.943 L 144.906 357.736 135.849 357.736 L 126.792 357.736
            126.792 290.961 L 126.792 224.186 113.396 223.980 L 100.000 223.774 99.803 192.257 L 99.606 160.740 135.652 160.936 L 171.698 161.132 171.895 192.642 "
            stroke="none"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}

export default LearnIcon;
